import { z } from 'zod'

export type OrganizationUser = {
  id: string
  firstName: string
  lastName: string
  email: string
  isEmailVerified: boolean
  passwordResetRequired: boolean
  permissions: OrganizationUserPermission[]
}

export enum RoleSlug {
  Admin = 'admin',
  Procurement = 'procurement',
  Production = 'production',
  Sales = 'sales'
}

export type OrganizationUserPermission = {
  id: string
  permissions: string[]
  roleSlug: RoleSlug
}

export const organizationUserInvitePayloadSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.email(),
  roleSlug: z.string()
})

export type OrganizationUserInvitePayload = z.infer<typeof organizationUserInvitePayloadSchema>
